import React, { useEffect, useState } from "react";
import SingleAudioForm from "../Partials/SingleAudioForm";
import SingleVideoForm from "../Partials/SingleVideoForm";
import SingleBookForm from "../Partials/SingleBookForm";
import { useParams, useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchSingleAudio, fetchSingleVideo, fetchSingleBook } from "../utils";
import { SingleLeaseWrapper } from "../../lease/Lease.styled";
import { IntroductionHeader } from "../../dashboard/Dashboard";

function SingleEducation() {
	let { category, id } = useParams();
	const [educationData, setEducationData] = useState(null);
	const [loading, setLoading] = useOutletContext();

	const getEducationData = async () => {
		let data;
		switch (category) {
			case "audio":
				data = await fetchSingleAudio(id);
				break;
			case "video":
				data = await fetchSingleVideo(id);
				break;
			default:
				data = await fetchSingleBook(id);
				break;
		}
		// Handle response data
		// console.log(data.length)
		if (data.length > 0) {
			// console.log({...data[0].attributes})
			// console.log(data)
			setEducationData({...data[0].attributes});
			setLoading(false);
		} else {
			setLoading(false);
			setEducationData({});
			toast.error("Error fetching data!");
		}
	};
	
	// On page load
	useEffect(() => {
		setLoading(true);
		getEducationData();
	}, []);

    const CurrentEducationForm = (props) => {
		// console.log(educationData)
		switch (category) {
			case "audio":
				return <SingleAudioForm {...props} />;
			case "video":
				return <SingleVideoForm {...props} />;
			case "book":
				return <SingleBookForm {...props} />;
			default:
				return <div className='text-center p-3'>[404] Error: Education category not found!</div>;
		}
	};


	return (

        <>
        <IntroductionHeader nav={true}/>
        <SingleLeaseWrapper className="mt-10">
        
     {
         // Show CurrentEducationForm if id is present and loading is false
         educationData && !loading ?  (
             <CurrentEducationForm
                 data={educationData}
                 setEducationData={setEducationData}
                 // updateLeaseObject={updateLeaseObject}
             />
          ) : (
             <div className='text-center fw-500 p-3'>Loading...</div>
         )
     }
 </SingleLeaseWrapper>
        </>
		
	);
}

export default SingleEducation;
